// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// packages
import { index } from 'd3-array';
import { json } from 'd3-fetch';
import {
  createFeed,
  createOfficeFeed,
  createRaceLookup,
  createRaceStore,
  createRaceFeed,
  createCandidateFeed,
  createCandidateLookup,
  createSubunitLookup,
  indexByApId,
} from './stores.js';
import { topojsonToGeoJson } from './utils/geography.js';
import { renderSvelteComponent } from './utils/render.js';

//components
import TwoColumnList from './components/TwoColumnList.svelte';
import Results from './components/Results.svelte';
import DataTime from './components/DataTime.svelte';
import AtAGlanceContainer from './components/AtAGlanceContainer.svelte';
import Watching from './components/Watching.svelte';
import ResultsMap from './components/ResultsMap.svelte';
import ResultsLegend from './components/ResultsLegend.svelte';

// URL for alpha and pub
import { STATE_URL, GEOGRAPHY_URL, SF_URL } from './constants.js';

/**
 * @type {Map<string, import('../types.d').Crosswalk>}
 */
const crosswalk = index(window.CROSSWALK, indexByApId);
//components

async function main() {
  // for live
  const feed = await createFeed(STATE_URL);
  const store = createRaceLookup(feed);

  // map data
  const topology = await json(GEOGRAPHY_URL);
  const [geography, roads, cities] = topojsonToGeoJson(topology, [
    'counties',
    'roads',
    'cities',
  ]);

  const racesOnPage = document.querySelectorAll('.race-result');
  /**  @type {import('./types.d').RaceFeed}  */
  let govRaceFeed;

  for (let idx = 0; idx < racesOnPage.length; idx++) {
    const target = racesOnPage[idx];
    const id = target.id;
    // console.log(id);
    const race = /**  @type {import('./types.d').RaceFeed}  */ (
      createRaceFeed(feed, id)
    );

    if (id === 'CA-G6119-2022-06-07') {
      govRaceFeed = race;
      renderSvelteComponent(
        Results,
        /** @type {HTMLElement} */ (document.getElementById(id)),
        { race: race, face: true, crosswalk }
      );
    } else {
      renderSvelteComponent(
        Results,
        /** @type {HTMLElement} */ (document.getElementById(id)),
        { race: race, face: false, crosswalk: '' }
      );
    }
  }

  const govRaceCandidateLookup = createCandidateLookup(govRaceFeed);
  const govRaceSubunitLookup = createSubunitLookup(govRaceFeed);

  ////MAP
  renderSvelteComponent(
    ResultsMap,
    /** @type {HTMLElement} */ (document.getElementById('results-map')),
    {
      geography,
      roads,
      cities,
      candidates: govRaceCandidateLookup,
      subunits: govRaceSubunitLookup,
      includeParty: false,
    }
  );
  renderSvelteComponent(
    ResultsLegend,
    /** @type {HTMLElement} */ (document.getElementById('results-legend')),
    {
      race: govRaceFeed,
    }
  );

  // RACES WE ARE WATCHING
  const localFeed = await createFeed(SF_URL);
  const watchingRace = document.querySelectorAll('.watching');

  for (let idx = 0; idx < watchingRace.length; idx++) {
    const t = watchingRace[idx];
    const watching_id = t.id;
    // console.log(id);
    const watchingFeed = /**  @type {import('./types.d').RaceFeed}  */ (
      createRaceFeed(localFeed, watching_id)
    );

    renderSvelteComponent(
      Watching,
      /** @type {HTMLElement} */ (document.getElementById(watching_id)),
      { race: watchingFeed }
    );
  }

  ///HOUSE
  const houseFeed = /**  @type {import('./types.d').RaceFeed}  */ (
    createOfficeFeed(feed, 'H')
  );

  renderSvelteComponent(
    TwoColumnList,
    /** @type {HTMLElement} */ (document.getElementById('House')),
    { races: houseFeed }
  );

  ////STATE SENATE
  const stateSenateFeed = /**  @type {import('./types.d').RaceFeed}  */ (
    createOfficeFeed(feed, 'Z')
  );

  renderSvelteComponent(
    TwoColumnList,
    /** @type {HTMLElement} */ (document.getElementById('StateSenate')),
    { races: stateSenateFeed }
  );

  ////STATE ASSEMBLY
  const stateAssemblyFeed = /**  @type {import('./types.d').RaceFeed}  */ (
    createOfficeFeed(feed, 'Y')
  );

  renderSvelteComponent(
    TwoColumnList,
    /** @type {HTMLElement} */ (document.getElementById('StateAssembly')),
    { races: stateAssemblyFeed }
  );

  //AT A GLANCE GOV AND AG

  const AtAGlanceGov = /** @type {import('./types.d').ReadableRace} */ (
    createRaceFeed(feed, 'CA-G6119-2022-06-07')
  );

  const AtAGlanceAG = /** @type {import('./types.d').ReadableRace} */ (
    createRaceFeed(feed, 'CA-A6142-2022-06-07')
  );

  const AtAGlancePrecincts = /** @type {import('./types.d').ReadableRace} */ (
    createRaceFeed(feed, 'CA-G6119-2022-06-07')
  );

  renderSvelteComponent(
    AtAGlanceContainer,
    /** @type {HTMLElement} */ (document.getElementById('aag-container')),
    {
      precincts: AtAGlancePrecincts,
      gov: AtAGlanceGov,
      ag: AtAGlanceAG,
      crosswalk,
    }
  );

  // const raceFeed = /** @type {import('./types.d').ReadableRace} */ (
  //   createRaceFeed(feed, 'CA-H5743-2022-05-24')
  // );

  // renderSvelteComponent(
  //   ExpectedVote,
  //   /** @type {HTMLElement} */ (document.getElementById('recall-results-eevp')),
  //   { race: raceFeed }
  // );

  // // candidates
  // const candidateRaceFeed = /** @type {import('./types.d').ReadableRace} */ (
  //   createRaceFeed(feed, 'CA-H8953-2022-04-05')
  // );

  // renderSvelteComponent(
  //   ResultsList,
  //   /** @type {HTMLElement} */ (
  //     document.getElementById('candidate-results-container')
  //   ),
  //   { race: candidateRaceFeed, crosswalk }
  // );

  renderSvelteComponent(
    DataTime,
    /** @type {HTMLElement} */ (document.getElementById('testing-container')),
    { race: houseFeed }
  );
}

main().catch(console.error);
